<button type="button" class="close" aria-label="Close" (click)="closeModal('')">
    <span aria-hidden="true">&times;</span>
</button>
<div class="mt-0">
    <app-info-form (formSubmit)="onSubmit($event)" (cancel)="closeModal('')" [submitting]="submitting"></app-info-form>
</div>
